export class AuctionLotSearchFilterItemRangeModel {
  label?: string;
  value: string;
  helpText?: string;
  minValue?: number;
  maxValue?: number;

  prefix?: string;

  step?: number = 1;
  floor?: number;
  ceiling?: number;

  static formatValue(model: AuctionLotSearchFilterItemRangeModel): string {
    if (model.minValue <= 0 && model.maxValue <= 0)
      return '';
    if (model.minValue <= 0 && model.maxValue > 0)
      return `Up to ${model.prefix}${model.maxValue}`;
    if (model.minValue >= 0 && model.maxValue <= 0)
      return `From ${model.prefix}${model.minValue}`;
    return `${model.prefix}${model.minValue} - ${model.prefix}${model.maxValue}`;
  }
}